import { Tag } from 'antd';
import { companyColors } from 'apps/investment/constants';
import { fundDistributorsOptions } from 'apps/investment/constants/fund-distributors';
import { eSignContractMutualFundStatusOptions } from 'apps/investment/constants/fund-econtrac';
import { fundEContractStatusColors } from 'apps/investment/constants/fund-econtracts';
import { DataTableColumnHeader } from 'common/data-table-column-header';
import { FilterFieldConfig } from 'common/dynamic-filter-form';
import BooleanIcons from 'common/ui/boolean-icons';
import { booleanCell, dateTimeCell, linkCell } from 'utils/cell-formatter';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/investment/fund-econtracts' }),
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: dateTimeCell,
  },
  {
    accessorKey: 'trading_account_manager',
    header: 'Nhà phân phối',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const value = getValue();

      return <Tag color={companyColors[value]}>{value}</Tag>;
    },
  },
  {
    accessorKey: 'fund_manager',
    header: 'Fund Manager',

    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const value = getValue();

      return <Tag color={companyColors[value]}>{value}</Tag>;
    },
  },
  {
    accessorKey: 'contract_number',
    header: 'Contract Number',
  },

  {
    accessorKey: 'status',
    header: 'Trạng thái',
    meta: {
      className: 'text-center',
    },

    cell: ({ getValue, row }) => {
      const value = getValue();
      const label = row.original.status_label;

      return (
        <Tag color={fundEContractStatusColors[value]}>{label || value}</Tag>
      );
    },
  },

  {
    accessorKey: 'contract_id',
    header: 'Contract Id',
  },
  {
    accessorKey: 'contract_is_allow_signing',
    header: 'Được ký',
    meta: {
      className: 'text-center',
    },
    cell: booleanCell,
  },

  {
    accessorKey: 'link',
    header: 'Đã có link hđ',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const value = getValue();
      return <BooleanIcons value={!!value} />;
    },
  },
];

export const filterConfig: FilterFieldConfig[] = [
  {
    name: 'status',
    type: 'select',
    label: 'Trạng thái',
    minWidth: '100px',
    defaultValue: 'all',
    options: eSignContractMutualFundStatusOptions,
  },
  {
    name: 'trading_account_manager',
    type: 'select',
    label: 'Nhà phân phối',
    minWidth: '100px',
    defaultValue: 'all',
    options: fundDistributorsOptions,
  },
];
